// @ts-nocheck
import React from 'react';

interface PoweredByFooterProps {
  show?: boolean;
  brandColor?: string;
  bgColor?: string;
  textColor?: string;
  className?: string;
}

/**
 * Powered By Footer Component
 * Shows "Powered by BRNDSH" branding with logo and link
 * Can be hidden based on tier
 */
const PoweredByFooter: React.FC<PoweredByFooterProps> = ({
  show = true,
  brandColor = '#667eea',
  bgColor = '#f9fafb',
  textColor = '#6b7280',
  className = ''
}) => {
  if (!show) return null;

  return (
    <div
      className={`powered-by-footer ${className}`}
      style={{
        padding: '12px 20px',
        borderTop: '1px solid rgba(255, 255, 255, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        backgroundColor: '#df0',
        backgroundImage: 'linear-gradient(315deg, #4080f2, #ffea00)',
        fontSize: '12px',
        color: '#ffffff',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        flexShrink: 0,
        fontWeight: 500,
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)'
      }}
    >
      <span style={{ fontSize: '12px', opacity: 0.95 }}>Powered by</span>

      {/* BRNDSH logo with link */}
      <a
        href="https://www.brndsh.io/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          transition: 'opacity 0.2s ease'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.opacity = '0.8';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        <img
          src="https://cdn.prod.website-files.com/6703f95fee8846f901ef895c/672327f7cee1ee616023f024_Vectors-Wrapper.svg"
          loading="lazy"
          width="80"
          height="auto"
          alt="BRNDSH"
          style={{
            display: 'block',
            maxHeight: '16px'
          }}
        />
      </a>

      <style>{`
        .powered-by-footer {
          transition: all 0.2s ease;
        }
      `}</style>
    </div>
  );
};

export default PoweredByFooter;
